import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "浏览内容",
    links: [
      { label: "电影推荐", to: "/category?type=movie" },
      { label: "电视剧热播", to: "/category?type=tv" },
      { label: "影视资讯", to: "/news" },
      { label: "全站搜索", to: "/search" },
    ],
  },
  {
    title: "关于星光",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "发展历程", to: "/about" },
      { label: "内容范围", to: "/about" },
      { label: "联系我们", to: "/about" },
    ],
  },
];

const socialIcons = ["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-video-chat-line"];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="px-4 md:px-6 pt-12 md:pt-16 pb-6">
        <div className="max-w-[1440px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 pb-10 border-b border-background-50/10">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2.5 mb-4">
                <span className="w-9 h-9 rounded-md bg-background-50/10 text-accent-400 flex items-center justify-center">
                  <i className="ri-star-smile-line text-lg w-[18px] h-[18px] flex items-center justify-center"></i>
                </span>
                <div className="flex flex-col leading-none">
                  <span className="font-heading text-lg font-semibold text-background-50 tracking-wide">星光传媒</span>
                  <span className="text-[10px] tracking-[0.28em] uppercase text-background-300/70 mt-1">
                    Starlight Media
                  </span>
                </div>
              </div>
              <p className="text-sm leading-relaxed text-background-300/80 max-w-md">
                星光传媒专注于影视作品推荐与影视资讯，覆盖电影、电视剧等多类别内容。我们相信，好故事值得被认真介绍，也值得被安静地看完。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <span className="text-xs text-background-400">关注我们</span>
                {socialIcons.map((icon) => (
                  <span
                    key={icon}
                    aria-label="社交平台"
                    className="w-8 h-8 rounded-md bg-background-50/5 text-background-300 flex items-center justify-center hover:bg-background-50/10 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    <i className={`${icon} text-base w-4 h-4 flex items-center justify-center`}></i>
                  </span>
                ))}
              </div>
            </div>
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h3 className="text-sm font-medium text-background-50 mb-4">{column.title}</h3>
                <ul className="space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-background-300/80 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
            <p className="text-xs text-background-400/80 leading-relaxed">
              © 2026 星光传媒 Starlight Media. 本网站所有影视作品、人物及资讯均为虚构演示内容。
            </p>
            <p className="text-xs text-background-400/60">内容展示用途 · 不提供在线播放与下载</p>
          </div>
        </div>
      </div>
    </footer>
  );
}